import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { ALERT } from "../actionTypes";

/* `token` is optional and only the B2B portal passes one, so the server can
   prove which partner is registering instead of trusting a code in the form.
   The website calls this with one argument, exactly as before. */
export const memberRegisterAction = (data, token) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });

    const response = await dispatch(
      postDataAPI("admin/individual/member/registration", data, token)
    );

    // Full body: { status, data:member, pay:{...}, message }
    return { data: response.data || {} };
  } catch (error) {
    // Surface the server's validation errors/message instead of swallowing them.
    return { data: error?.response?.data || {} };
  }
};

export const memberOtherRegisterAction = (data, token) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });

    const response = await dispatch(
      postDataAPI("admin/other/member/registration", data, token)
    );

    // Full body: { status, data:member, pay:{...}, message }
    return { data: response.data || {} };
  } catch (error) {
    // Surface the server's validation errors/message instead of swallowing them.
    return { data: error?.response?.data || {} };
  }
};

/* The four membership fees, for the registration form (public). */
export const getMembershipFees = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("admin/membership/fees"));
    return response.data.data || null;
  } catch (error) {
    return null;
  }
};

/* Confirm a membership payment - the server re-checks it with Razorpay. */
export const membershipPaySuccess = (data) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("admin/membership/pay-success", data)
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { status: "failed", message: "Payment could not be confirmed." };
  }
};

/* Start a membership renewal - the server creates a fresh Razorpay order. */
export const renewMembership = (data) => async (dispatch) => {
  try {
    const response = await dispatch(postDataAPI("admin/membership/renew", data));
    return response.data;
  } catch (error) {
    return error.response?.data || { status: "failed", message: "Could not start renewal." };
  }
};

/* Confirm a renewal payment - extends the membership validity by a year. */
export const renewMembershipSuccess = (data) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("admin/membership/renew-success", data)
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { status: "failed", message: "Renewal could not be confirmed." };
  }
};

// export const changePassword = (data) => async (dispatch) => {
//   try {
//     const token = localStorage.getItem("centerToken");
//     dispatch({
//       type: ALERT,
//       payload: { loading: true },
//     });
//     const response = await dispatch(
//       postDataAPI("center/change-password", data, token)
//     );
//     dispatch({
//       type: ALERT,
//       payload: { success: response.data.message },
//     });
//     dispatch({
//       type: ALERT,
//       payload: { loading: false },
//     });
//     return true;
//   } catch (error) {
//     dispatch({
//       type: ALERT,
//       payload: { loading: false },
//     });
//     dispatch({
//       type: ALERT,
//       payload: { loading: false, error: error.response.data.message },
//     });
//     return false;
//   }
// };

// export const centerUpdate = (data) => async (dispatch) => {
//   try {
//     const token = localStorage.getItem("centerToken");
//     dispatch({ type: ALERT, payload: { loading: true } });
//     const response = await dispatch(
//       postDataAPI("center/edit-center", data, token)
//     );
//     dispatch({
//       type: ALERT,
//       payload: { loading: false, success: response.data.message },
//     });
//     dispatch({ type: ALERT, payload: { loading: false } });
//     return true;
//   } catch (error) {
//     dispatch({ type: ALERT, payload: { loading: false } });
//     if (error.response?.data?.message == "Validation errors") {
//       Object.entries(error.response.data.data).map((d) => {
//         dispatch({
//           type: ALERT,
//           payload: { error: d[1][0] },
//         });
//       });
//     }
//     return false;
//   }
// };

// export const updateStaffPic = (data) => async (dispatch) => {
//   try {
//     const token = localStorage.getItem("centerToken");
//     dispatch({ type: ALERT, payload: { loading: true } });
//     const response = await dispatch(
//       postDataAPI("center/update/staff/image", data, token)
//     );
//     dispatch({
//       type: ALERT,
//       payload: { loading: false, success: response.data.message },
//     });
//     dispatch({ type: ALERT, payload: { loading: false } });
//     return true;
//   } catch (error) {
//     dispatch({ type: ALERT, payload: { loading: false } });
//     if (error.response?.data?.message == "Validation errors") {
//       Object.entries(error.response.data.data).map((d) => {
//         dispatch({
//           type: ALERT,
//           payload: { error: d[1][0] },
//         });
//       });
//     }
//     return false;
//   }
// };

// export const centerLogin = (data) => async (dispatch) => {
//   try {
//     dispatch({
//       type: ALERT,
//       payload: { loading: true },
//     });
//     const response = await dispatch(postDataAPI("center/login", data));

//     localStorage.setItem("centerToken", response.data.data.token);
//     dispatch({
//       type: CENTER_AUTH_SUCCESS,
//       payload: response.data.data,
//     });
//     dispatch({
//       type: ALERT,
//       payload: { loading: false, success: response.data.message },
//     });
//   } catch (error) {
//     dispatch({
//       type: ALERT,
//       payload: { loading: false, error: error.response.data.message },
//     });
//     dispatch({
//       type: CENTER_AUTH_FAIL,
//     });
//   }
// };

// export const centerDashboard = () => async (dispatch) => {
//   try {
//     const token = localStorage.getItem("centerToken");
//     dispatch({
//       type: ALERT,
//       payload: { loading: true },
//     });
//     const response = await dispatch(getDataAPI("center/dashboard", token));
//     dispatch({
//       type: CENTER_AUTH_SUCCESS,
//       payload: response.data.data,
//     });
//     dispatch({
//       type: ALERT,
//       payload: { loading: false },
//     });
//   } catch (error) {
//     dispatch({
//       type: ALERT,
//       payload: { loading: false },
//     });
//     dispatch({
//       type: CENTER_AUTH_FAIL,
//     });
//   }
// };
// export const editCenter = () => async (dispatch) => {
//   try {
//     const token = localStorage.getItem("centerToken");
//     dispatch({
//       type: ALERT,
//       payload: { loading: true },
//     });
//     const response = await dispatch(getDataAPI("center/profileGet", token));
//     dispatch({
//       type: CENTER_REGISTER_DETAILS,
//       payload: response.data.data,
//     });
//     dispatch({
//       type: ALERT,
//       payload: { loading: false },
//     });
//   } catch (error) {
//     dispatch({
//       type: ALERT,
//       payload: { loading: false },
//     });
//     // dispatch({
//     //   type: CENTER_AUTH_FAIL,
//     // });
//   }
// };
